import React from 'react';

export const insertLineBreaks = (text) =>
  text.split('\n').map((line, index, textLines) => (
    <React.Fragment key={index}>
      {line}
      {index !== textLines.length - 1 && <br />}
    </React.Fragment>
  ));
